/* eslint-disable react/jsx-handler-names */
/* eslint-disable react/button-has-type */
import { animated, useSpring } from "@react-spring/web";
import classNames from "classnames";

// Hooks
import useTranslate from "hooks/useTranslate";

// Icons
import PlayIcon from "assets/icons/play.svg?react";

// Types
import { GAME_MODE } from "types/Games";

import "./styles.sass";

type GameModeButtonsProps = {
  mode: string | null;
  onDemoInit: () => void;
  onRealInit: () => void;
};

const GameModeButtons = (props: GameModeButtonsProps) => {
  const { mode, onDemoInit, onRealInit } = props;

  const t = useTranslate();

  const spring = useSpring({
    x: mode !== GAME_MODE.DEMO ? 0 : 126,
  });

  const demoClass = classNames("GameModeButtons__btn", {
    active: mode === GAME_MODE.DEMO,
  });
  const realClass = classNames("GameModeButtons__btn", {
    active: mode !== GAME_MODE.DEMO,
  });

  return (
    <div className="GameModeButtons">
      <button className={realClass} onClick={onRealInit}>
        {t("profile.game.button")} {mode !== GAME_MODE.DEMO && <PlayIcon />}
      </button>
      <button className={demoClass} onClick={onDemoInit}>
        {t("casino.lobby.demo")} {mode === GAME_MODE.DEMO && <PlayIcon />}
      </button>

      <animated.div className="GameModeButtons__active" style={{ ...spring }} />
    </div>
  );
};

export default GameModeButtons;
